import { IconButton } from '../'; 
import { theme } from '../../theme';
import { useCallback, useState, useEffect } from 'react';
import { StyledMailchimpSubscribeForm } from './MailchimpSubscribeForm.styled';

const MailchimpSubscribeForm = ({ status, message, subscribe }) => {
  const [focused, setFocused] = useState(false);
  const [text, setText] = useState('');

  const setTextOnChange = useCallback((data) => {
    setText(data);
  }, [setText]);

  useEffect(() => {
    if (status === "success") setText('');
  }, [status]);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  console.error(`===>>>>> ${status}: ${message}`)
  return (
    <StyledMailchimpSubscribeForm>
      <div className='form-subscribe-container'>
        <input
          className='form-subscribe-input'
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          value={text}
          onChange={(event) => setTextOnChange(event.target.value)}
          placeholder='Your e-mail'
        />
        <div className='form-subscribe-button-holder'>
          <IconButton
            onClick={() => subscribe({ EMAIL: text.toLowerCase() })}
            animated={false}
	    disabled={!emailRegex.test(text) || status === 'sending'}
            backgroundOverwrite={theme.buttonGreen}
            backgroundOverwriteHover={theme.buttonLightGreen}
            borderOverwrite='rgba(0, 0, 0, .16)'>
            <div className='form-subscribe-button'>
              <div>{status === 'sending' ? 'Sending...' : 'Subscribe'}</div>
              <img src='/assets/generate_voice.svg' />
            </div>
          </IconButton>
        </div>
      </div>
      {status === 'success' && <div className='form-subscribe-success'>{message}</div>}
      {status === 'error' && <div className='form-subscribe-error'>Wrong email format!</div>}
    </StyledMailchimpSubscribeForm>
  );
};

export default MailchimpSubscribeForm;
